export const productImageZoomTrigger = {
  expand: 'Expand image',
};

export const productImageZoomDialog = {
  close: 'Close',
};

export const productImageZoom = {
  productImageZoomTrigger,
  productImageZoomDialog,
};
